export const isIOS = () => {
  const browserInfo = navigator.userAgent.toLowerCase();

  if (browserInfo.match('iphone') || browserInfo.match('ipad')) {
    return true;
  } if (['iPad Simulator', 'iPhone Simulator', 'iPad', 'iPhone'].includes(navigator.platform)) {
    return true;
  } return false;
}
